import {Carteira, CarteiraFilter, CarteiraGravarTodos} from "./carteira.model";
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {IPaginatedResponse, IService} from 'maps-angular-components';
import {catchError, retry} from "rxjs/operators";

import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {PageableCarteiraFilter} from "./pageable-carteira-filter";
import {PaginationResponse} from "../shared/form/pagination-response";
import {handleError} from "../shared/util/error-util";

@Injectable({
  providedIn: 'root'
})
export class CarteiraService implements IService<Carteira> {

  private readonly httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});

  url = "/v1/carteiras";

  constructor(private readonly http: HttpClient) {
  }

  parsePaginatedResponse(response): IPaginatedResponse<Carteira> {
    return {
      total: null,
      data: response.map(item => new Carteira(item))
    };
  };

  findFromEnquadramentoEAtivoPaginado(filter: PageableCarteiraFilter): Observable<PaginationResponse> {
    const headers = this.httpHeaders;
    const params = this.buildSearchPageableParams(filter);
    const options = {headers, params};
    return this.http.get<PaginationResponse>(`${this.url}/ativo`, options).pipe(catchError(handleError));
  }

  autocomplete(identificador: string, endpoint = ''): Observable<Carteira> {
    const headers = this.httpHeaders;
    const options = {headers};
    return this.http.get<any>(`${this.url}/${endpoint}?val=${encodeURIComponent(identificador)}`, options).pipe(catchError(handleError));
  }

  update(carteira: Carteira) {
    const headers = this.httpHeaders;
    return this.http.post<any>(`${this.url}/${carteira.cnpj}`, carteira, {headers}).pipe(
      retry(2)
    );
  }

  updateAll(filter: CarteiraFilter, ativaEnquadramento: boolean, processamentoAuto: boolean) {
    let model = this.buildSearchParams(filter);
    model.shouldAtivar = ativaEnquadramento;
    model.shouldAuto = processamentoAuto;

    const headers = this.httpHeaders;
    return this.http.post<any>(`${this.url}/all`, model, {headers}).pipe(
      retry(2)
    );
  }

  buildSearchParams(filter: CarteiraFilter): CarteiraGravarTodos {
    let params: CarteiraGravarTodos = new CarteiraGravarTodos();

    if (filter.nomeCompleto) {
      params.nomeCompleto = filter.nomeCompleto;
    }

    if (filter.cnpj) {
      params.nomeOrCnpj = filter.cnpj;
    }
    if (filter.ativa !== null) {
      params.ativa = filter.ativa;
    }
    if (filter.auto !== null) {
      params.auto = filter.auto;
    }

    return params;
  }

  updateOrCreate(carteiras: Carteira[]) {
    const headers = this.httpHeaders;
    return this.http.post<any>(`${this.url}`, carteiras, {headers}).pipe(
      retry(2)
    );
  }

  private buildSearchPageableParams(filter: PageableCarteiraFilter) {
    let params: HttpParams = new HttpParams();

    if (filter.nomeCompleto) {
      params = params.set('nomeCompleto', filter.nomeCompleto);
    }

    if (filter.nome) {
      params = params.set('nome', filter.nome);
    }
    if (filter.ativa !== null && filter.ativa !== undefined) {
      params = params.set('ativa', '' + filter.ativa);
    }
    if (filter.auto  !== null && filter.auto !== undefined) {
      params = params.set('auto', '' + filter.auto);
    }

    params = params.set('page', filter.pageNumber);

    params = params.set('size', filter.pageSize);


    return params;

  }

  findById(id: number) :Observable<Carteira>{
    const headers = this.httpHeaders;
    return this.http.get<Carteira>(`${this.url}/${id}`, {headers}).pipe(catchError(handleError));
  }

  exportPdf(value: any): Observable<HttpResponse<Blob>> {
    const headers = this.httpHeaders;
    const params = this.buildSearchPageableParams(value).set("size", '99999999');
    return this.http.get(`${this.url}/export/pdf`, {
      headers,
      responseType: "blob",
      observe: "response",
      params
    }).pipe(catchError(handleError));
  }

  exportXlsx(value: any): Observable<HttpResponse<Blob>> {
    const headers = this.httpHeaders;
    const params = this.buildSearchPageableParams(value).set("size", '99999999');
    return this.http.get(`${this.url}/export/xlsx`, {
      headers,
      responseType: "blob",
      observe: "response",
      params
    }).pipe(catchError(handleError));
  }
}
